import React, { useEffect, useRef, useState } from "react";
import { PrinterFill } from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactPrint from "react-to-print";
import config from "../component/config";
import "bootstrap/dist/css/bootstrap.min.css";
import "./receipt.css";

export default function PdfTemplate({ data }) {
  const [show, setShow] = useState(false);
  const [Dates, setDates] = useState("");
  const [ecData, setEcData] = useState([]);
  const ref = useRef();

  // Extracting data from props
  const { id, matricule, nom, prenom, classe, montant, reste } = data;

  useEffect(() => {
    // Set current date
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
    setDates(date);

    // Fetch school details dynamically
    const getEcole = async () => {
      try {
        const reqdata = await fetch(`${config.apiBaseUrl}/schoolUp.php/1`);
        const resdata = await reqdata.json();
        setEcData(resdata);
      } catch (error) {
        console.error("Erreur lors du chargement des données :", error);
      }
    };
    getEcole();
  }, []);

  return (
    <>
      <Button variant="light" onClick={() => setShow(true)}>
        <PrinterFill />
      </Button>

      <Modal show={show} onHide={() => setShow(false)} backdrop="static" keyboard={false}>
        <Modal.Body>
          <div className="receipt-container mx-auto" ref={ref}>
            {/* Header Section */}
            <div className="receipt-header d-flex justify-content-between align-items-center">
              <div className="school-info text-center flex-grow-1">
                <h2 className="school-name">{ecData.nomec}</h2>
                <p className="contact-info">📞 {ecData.contact} | 🏠 {ecData.bp}</p>
                <p className="receipt-number"><strong>Reçu #: {id}</strong></p>
              </div>
              <div className="logo-section text-end">
                <img src={`${config.apiBaseUrl}/logo/${ecData.logo}`} className="receipt-logo" alt="Logo" />
                <p className="date-info mt-1"><strong>Date:</strong> {Dates}</p>
              </div>
            </div>

            <hr />

            {/* Payment Details */}
            <div className="receipt-body">
              <h3 className="receipt-title text-center mb-3">Reçu de paiement</h3>

              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">Reçu de M/Mlle</label>
                  <input type="text" value={`${nom} ${prenom}`} className="form-control form-control-sm" readOnly />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Matricule</label>
                  <input type="text" value={matricule} className="form-control form-control-sm" readOnly />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <label className="form-label">Classe</label>
                  <input type="text" value={classe} className="form-control form-control-sm" readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Montant payé</label>
                  <input type="text" value={`${montant} FCFA`} className="form-control form-control-sm" readOnly />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-8">
                  <label className="form-label">Motif</label>
                  <input type="text" value="Frais d'inscription" className="form-control form-control-sm" readOnly />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Reste à payer</label>
                  <input type="text" value={`${reste} FCFA`} className="form-control form-control-sm" readOnly />
                </div>
              </div>

              <p className="text-end signature"><strong>La Directrice</strong></p>

              {/* Print Button */}
              <ReactPrint 
                trigger={() => <button className="btn btn-primary mt-3 w-100">Imprimer</button>} 
                content={() => ref.current} 
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShow(false)} className="btn btn-secondary w-100">
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
